// extracted by mini-css-extract-plugin
export default {"hero":"HeroSection_hero__LTd9k","img-container":"HeroSection_img-container__Tog0k","img":"HeroSection_img__ykRLb","text":"HeroSection_text__bBTrd"};